import React, { useState, useEffect } from 'react';
import linkIcon from '../../../assets/images/link.svg'
import { fetchShipmentById } from '../../../redux/shipmentSlice.js'; // Import actions from the slice
import { useSelector, useDispatch } from 'react-redux';
import MainTable from '../../../components/Table/PaginationTable';
import { ProductColumnDefDefaultFn } from '../columns/ColumnDefShipment.js';
import { useParams } from 'react-router-dom';
import { getDate } from '../../../helpers/helperFunction.js';

const ShipmentDetails = () => {
    // const shipmentDetails = useSelector((state) => console.log('@@@@:',state))
    const productData = useSelector(state =>
        state.shipment.shipmentDetails && state.shipment.shipmentDetails.data
            ? state.shipment.shipmentDetails.data.shipmentProducts
            : []);
    const shipmentDetails = useSelector((state) =>state.shipment.shipmentDetails?.data || {});
        // console.log("finalllll shipmentDetails", shipmentDetails);
        // console.log("finalllll productData", productData);
    const dispatch = useDispatch();
    const { shipmentId } = useParams();
    const productColumn = ProductColumnDefDefaultFn();

    useEffect(() => {
        // console.log("MY shipmentId ",shipmentId); // Log it or use it as needed
        // const shipmentId = '187'; 
        dispatch(fetchShipmentById({shipmentId, type: 'view'}));
    }, [dispatch]);
    return (
        <>
         <div>
            <h1 className="fprimary">Shipment Details </h1>
                <h5 className="">Review the Shipment</h5>
            </div>
            <div className="card mt-3 bg-stage">
                <div className="card-body">
                    <div>
                    <p className="font-13 mb-0 text-black-50">Invoice Number:</p>
                        <div className="bg-slash font-14 mb-3">{shipmentDetails?.invoiceNumber}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0 ">Invoice Date</p>
                                    <div className="bg-slash font-14">{getDate(shipmentDetails?.invoiceDate)}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Supplier</p>
                                    <div className="bg-slash font-14">{shipmentDetails.sellerCompany?.companyName || 'N/A'}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Seller Unit</p>
                                    <div className="bg-slash font-14">{shipmentDetails.sellerCompany?.companyName}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Buyer Unit</p>
                                    <div className="bg-slash font-14">{shipmentDetails.buyerCompany?.companyName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                            <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Transport Mode</p>
                                    <div className="bg-slash font-14">{shipmentDetails?.shipmentTransportMode}</div>
                                </div>
                                <div className="left-box w-100 ps-2">
                                    <p className="font-13 mb-0">Link Buyer Purchase</p>
                                    <div className="bg-slash font-14">{shipmentDetails.orderNumber}</div>
                                    <span className="ms-2"><img src={linkIcon} alt="Link" /></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="mt-3">
                                <h4 className="font-18">Shipment Description</h4>
                                <p className="font-13">
                                    {shipmentDetails.shipmentDescription}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-3 bg-stage">
                <div className="card-body">

                </div>
            </div>

            </div>
            <div className='mt-5 ml-2'>
                <h1 className="fprimary">Product Details</h1>
            </div>
            <MainTable
                columns={productColumn}
                data={productData}
                enablePagination={false}
                className='mt-5'
            // initialPageSize={pageSize}
            // pageNumber={pageNumber} // Use the correct prop name as expected by MainTable
            // onPageSizeChange={handlePageSizeChange}
            // onPageIndexChange={handlePageIndexChange}
            />
        </>
    );
};

export default ShipmentDetails;
